import * as display from './display'
import * as flex from './flex'
import * as fontWeight from './font-weight'
import * as height from './height'
import * as margin from './margin'
import * as position from './position'
import * as textAlign from './text-align'
import * as textTransform from './text-trasform'
import * as whiteSpace from './white-space'
import * as width from './width'

export {
  textAlign,
  display,
  margin,
  textTransform,
  fontWeight,
  whiteSpace,
  flex,
  height,
  width,
  position,
}
